module.exports = __webpack_public_path__ + "img/icon-arrow-up.13d207a8.svg";